import axios, { type AxiosRequestConfig } from 'axios';
import type {
  RequestParams,
  ResponseRegions,
  Region,
  ResponseModelOffers,
} from '~/interfaces/api';
import { API } from '~/api/api';
import { useGlobalStore } from '~/stores/global';
import type { PostBodyFilters } from '~/interfaces/app';

export async function fetchRegionByIp(): Promise<number> {
  try {
    const res = await axios.get(`/api/region-id/ `);
    return res?.data;
  } catch (err) {
    return 1;
  }
}

export async function fetchRegion(id: number): Promise<Region | null> {
  try {
    const res = await API.get(`/regions/${id}`);
    return res?.data;
  } catch (err) {
    return null;
  }
}

export async function fetchRegions(
  params: RequestParams
): Promise<ResponseRegions> {
  try {
    const res = await API.get(`/regions`, {
      params,
    });
    return res?.data;
  } catch (err) {
    return { list: [], page: 1, per_page: 0, total: 0 };
  }
}

export async function getModelsOffersList(
  id: string | number,
  data: PostBodyFilters | ResponseModelOffers | null = null,
  params: RequestParams
): Promise<ResponseModelOffers> {
  const controller = new AbortController();
  if (!import.meta.env.SSR) {
    const globalStore = useGlobalStore();
    globalStore.setCancelToken(controller);
  }
  const res = await API.post(`/models/${id}/offers`, data || { filters: [] }, {
    params,
    signal: controller.signal,
  })
    .then((data) => data)
    .catch(() => {
      return null;
    });
  return res?.data;
}

export async function getOffersForModelsList(
  data: ResponseModelOffers | null = null,
  params: RequestParams
): Promise<ResponseModelOffers> {
  const controller = new AbortController();
  if (!import.meta.env.SSR) {
    const globalStore = useGlobalStore();
    globalStore.setCancelToken(controller);
  }
  const res = await API.post(`/models/offers`, data, {
    params,
    signal: controller.signal,
  })
    .then((data) => data)
    .catch(() => {
      return null;
    });
  return res?.data;
}

export async function getArticles(modelID: string | number | null) {
  const url = modelID
    ? `/models/${modelID}/blog_articles`
    : '/blog/top_articles';
  try {
    const res = await API.get(url);
    return res.data;
  } catch (err) {
    return { items: [], total: 0 };
  }
}

export async function getArticlesByCategory(
  categoryID: string | number,
  params: AxiosRequestConfig | null = null
) {
  const id = Number(categoryID);
  if (id && id > 2147483647) {
    return { items: [], total: 0 };
  }
  const url = `/categories/${categoryID}/blog_articles`;
  try {
    const res = await API.get(url, params || {});
    return res.data;
  } catch (err) {
    return { items: [], total: 0 };
  }
}
